export default {
  toasts: {
    success: 'Geschenkkarte erfolgreich eingelöst.',
    error: 'Einlösen der Geschenkkarte fehlgeschlagen.',
  },
  title: 'Geschenkkarte einlösen',
  subtitle: 'Gib den Geschenkkartencode und den Betrag ein, der von der Rechnung des Gastes abgezogen werden soll.',
  form: {
    amount: {
      label: 'Einzulösender Betrag',
    },
    code: {
      label: 'Geschenkkartencode',
    },
  },
  buttons: {
    redeem: 'Einlösen',
    cancel: 'Abbrechen',
  },
};
